// ---------------------------------------------------------------------------
// YouTube channel config for the homepage video strip.
//
// The strip reads the channel's public RSS feed at page load, so it always
// shows your latest uploads with nothing to maintain. No API key is needed.
//
// Because a static site cannot call youtube.com directly (CORS), the request
// goes through a public CORS proxy. Two are tried in order, so if one is down
// the other takes over. If both fail, the strip shows a "visit our channel"
// card rather than an empty or broken section.
// ---------------------------------------------------------------------------

export const YOUTUBE = {
  handle: "@rango_ecycles",
  channelId: "UCWqSKZ4s0JuhyivyTmLa-Ng",
  channelUrl: "https://www.youtube.com/@rango_ecycles",
  maxVideos: 12,
};

export const FEED_URL = `https://www.youtube.com/feeds/videos.xml?channel_id=${YOUTUBE.channelId}`;

// Tried in order. Each takes the target URL and returns raw XML.
export const CORS_PROXIES = [
  (url) => `https://api.allorigins.win/raw?url=${encodeURIComponent(url)}`,
  (url) => `https://corsproxy.io/?url=${encodeURIComponent(url)}`,
  (url) => `https://cors-anywhere.herokuapp.com/${url}`,
];

// Fallback videos shown if all proxies fail. Update occasionally by visiting
// your YouTube channel and copying recent video IDs and titles.
export const FALLBACK_VIDEOS = [
  {
    id: "UCWqSKZ4s0JuhyivyTmLa-Ng",
    title: "Visit our YouTube channel for the latest videos",
    published: new Date().toISOString(),
    url: YOUTUBE.channelUrl,
    thumbnail: null, // Will show fallback placeholder
  },
];
